import UpdateManager from 'components/TrainingWish/UpdateManager'
import UpdateTraining from 'components/TrainingWish/UpdateTraining'
import Button from 'components/UI/CoreUIButton'
import SectionTitle from 'components/UI/SectionTitle'
import { API_TRAINING_WISHES_ACTIONS } from 'constants/api-v2'
import { useI18n } from 'context/I18nProvider'
import useSWR from 'hooks/swr'
import PropTypes from 'prop-types'
import { useModal } from 'react-modal-hook'
import type { TrainingWishProvision } from './Distribution'

interface HeaderProps {
  trainingWish: TrainingWishProvision
  onUpdate: () => Promise<unknown>
}

function Header({ trainingWish, onUpdate }: HeaderProps) {
  const { i18n, i18name } = useI18n()
  const { data: permissions } = useSWR(API_TRAINING_WISHES_ACTIONS.replace(':id', String(trainingWish.id)))

  const manager = `${trainingWish.manager?.last_name} ${trainingWish.manager?.first_name}`.toLowerCase()
  const canChangeTraining = permissions?.updateTraining
  const canChangeManager = permissions?.assign

  const trainingName = i18name(trainingWish?.training)
  const [showUpdateTraining, hideUpdateTraining] = useModal(
    () => (
      <UpdateTraining
        doneAction={onUpdate}
        onClose={hideUpdateTraining}
        id={trainingWish.id}
        title={trainingName}
        isFictive={trainingWish.training.fictive}
      />
    ),
    [trainingWish.id],
  )

  const [showUpdateManager, hideUpdateManager] = useModal(() => (
    <UpdateManager doneAction={onUpdate} onClose={hideUpdateManager} id={trainingWish.id} />
  ))

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <SectionTitle level={1}>
          {`${i18n('page_title.manage_provision')} - ${i18name(trainingWish.training)}`}
        </SectionTitle>
        {canChangeTraining && <Button onClick={showUpdateTraining} variant="tertiary" singleIcon="pen" />}
      </div>
      <div className="flex items-center gap-4 text-lg">
        <p>
          {' '}
          <span className="text-slate-500">{i18n('manager')} :</span> {manager}
        </p>
        {canChangeManager && <Button onClick={showUpdateManager} variant="tertiary" singleIcon="pen" />}
      </div>
    </div>
  )
}

Header.propTypes = {
  trainingWish: PropTypes.shape({
    id: PropTypes.number.isRequired,
    training: PropTypes.object.isRequired,
    manager: PropTypes.shape({
      last_name: PropTypes.string,
      first_name: PropTypes.string,
    }).isRequired,
  }).isRequired,
  onUpdate: PropTypes.func,
}

export default Header
